"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isAxiosError = (error) => {
    return error.response != undefined && error.response.data != undefined;
};
const axiosErrorToBoclipsApiError = (error) => {
    if (isAxiosError(error)) {
        const boError = {
            error: error.response?.data.error || error.response?.statusText,
            message: error.response?.data.message || 'Request failed',
            reasons: error.response?.data.reasons,
            path: error.response?.data.path || error.request.path,
            status: error.response?.data.status || error.response?.status,
            timestamp: error.response?.data.timestamp ||
                new Date(error.response?.headers.date),
        };
        return Promise.reject(boError);
    }
    else {
        return Promise.reject(error);
    }
};
exports.default = axiosErrorToBoclipsApiError;
//# sourceMappingURL=axiosErrorToBoclipsApiError.js.map